import { ACTIVITY_GET } from '../actions/activity'
import apiCall from './call'

const actions = {
  [ACTIVITY_GET]: ({ commit, dispatch }, requestObj) => {
    return new Promise((resolve, reject) => {
      let qs = {}
      if (requestObj.hasOwnProperty('paginate')) {
        qs.paginate = requestObj.paginate
      }
      if (requestObj.hasOwnProperty('page')) {
        qs.page = requestObj.page
      }
      apiCall({ url: requestObj.model + '/' + requestObj.modelId + '/activity', qs })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}

export default {
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/activity.js